<template>
  <div class="col-md-4">

    <div style="padding-top: 20px;padding-bottom: 10px;color: #ec2553;">Booking Summary</div>
    <div class="row">
      <div class="col-8 col-md-8">
        <div style="font-size: 13px;"> Total Ticket Fee </div>
      </div>
      <div class="col-4 col-md-4 text-right" style="font-size: 13px;">
        Rs. {{ seatdetail.count }} x {{ seatdetail.ticketprice }}
      </div>
      <div class="col-8 col-md-8" v-if="seatdetail.tdcharge">
        <div style="font-size: 13px;padding-top: 5px;"> 3D Charge
        </div>
      </div>

      <div class="col-4 col-md-4 text-right" style="font-size: 13px;padding-top: 5px;" v-if="seatdetail.tdcharge">

        Rs.{{ seatdetail.tdcharge * seatdetail.count }}
      </div>
      <div class="col-8 col-md-8">
        <div style="font-size: 13px;padding-top: 5px;"> Convenience fees (Inc.GST)

        </div>
      </div>

      <div class="col-4 col-md-4 text-right" style="font-size: 13px;padding-top: 5px;">

        Rs.{{ seatdetail.serviceamount * seatdetail.count }}
      </div>

    </div>


    <div class="col-md-12" style="padding: 10px 0px 5px 0px;border-top: dashed 1px #000 !important;margin-top: 10px;">
      <div class="row">

        <div class="col-8 col-md-8">
          <div style="font-size: 13px;"> Total</div>
        </div>

        <div class="col-4 col-md-4 text-right" style="font-size: 13px;">

          Rs. {{ seatdetail.amount }}
        </div>

      </div>









    </div>




    <div class="col-md-12" style="border-top: dashed 1px #848484 !important;margin-top: 10px;">
      <div class="row">

        <div class="col-md-12">
          <div style="font-size: 13px;margin-top: -9px;text-align: center;"> <span
              style="background-color: #fff;padding: 4px;color: #3b3b3b;"> &amp; </span></div>
        </div>



      </div>









    </div>

    <div class="row">
      <!-- {{ cartdetails }} -->
      <div class="col-8 col-md-8" style="padding-top: 10px;">
        <div style="font-size: 13px;"> Food &amp; Beverage <span><i class="fa fa-trash-o" aria-hidden="true"
              style="color: #ec2553;padding-left: 5px;"></i>
          </span></div>
      </div>

      <div class="col-4 col-md-4 text-right" style="font-size: 13px; padding-top: 10px;">

        {{ cafetotalPrice }}
      </div>

    </div>


    <div class="row" v-for="(item, index) in cartdetails" :key="index">
      <div class="col-8 col-md-8" style="padding-top: 10px;">
        <div style="font-size: 13px;color: #969696;"><span style="padding-right: 5px;"><a
              @click="removefromcart(item.pdtid)"><i aria-hidden="true" style="color: #636363;padding-left: 5px;"
                class="fa fa-times-circle"></i></a>
          </span> {{ item.pdtname }}<span style="font-weight: bold; color: #747474;"> [{{ item.qty }}]</span></div>
      </div>
      <div class="col-4 col-md-4 text-right" style="font-size: 13px;color: #a2a2a2; padding-top: 10px;">
        {{ parseFloat(item.pdtprice) * parseInt(item.qty) }}
      </div>
    </div>

    <div class="row">
      <div class="col-8 col-md-8" style="padding-top: 10px;">
        <div style="font-size: 16px;color: #ec2553;font-weight: 600;">
          Amount Payable </div>
      </div>
      <div class="col-4 col-md-4 text-right" style="font-size: 16px;color: #ec2553;font-weight: 600;padding-top: 10px;">
        {{ parseFloat(cafetotalPrice) + parseFloat(seatdetail.amount) }}
      </div>
    </div>
    <div class="form-group" style="margin-top: 15px;">
      <input type="text" style="width: 100%;text-align: left;padding-bottom: 20px;padding-top: 20px;padding-left: 10px;"
        placeholder="Name* " v-model="customer.name">
    </div>

    <div class="form-group">
      <input type="text" style="width: 100%;text-align: left;padding-bottom: 20px;padding-top: 20px;padding-left: 10px;"
        placeholder="E-mail Address*" v-model="customer.email">
    </div>
    <div class="form-group">
      <input type="text" style="width: 100%;text-align: left;padding-bottom: 20px;padding-top: 20px;padding-left: 10px;"
        placeholder="Mobile No*" v-model="customer.mobile">
    </div>





    <!-- <div style="background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%); text-align: center;padding: 8px;border-radius: 3px; margin-top: 20px;"> <a data-toggle="modal" data-target="#largeModal" href="#" style="color: white;">Proceed</a> </div> -->
    <button
      style="background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%); text-align: center;padding: 8px;border-radius: 3px; margin-top: 20px;border: none;width: 100%;color: #fff;"
      @click="confirmOrder">Proceed</button>
    <!-- <div style="margin-bottom: 30px;background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%); text-align: center;padding: 8px;border-radius: 3px; margin-top: 20px;" > <a  style="color: white;">Proceed</a> </div> -->

    <div id="msgWrap" v-if="notify" v-html="notify"></div>


  </div>
</template>

<script>
import { URL } from "@/conf.js";
// import razorpay from "razorpay";
import axios from "axios";

export default {
  props: {
    seatdetail: null,
    cartdetails: null,
  }
  , data: () => ({
    qnty: {},
    proid: [],
    paymentObject: null,
    customer: {
      loginCode: localStorage.getItem("loginCode"),
      mobile: null,
      email: null,
      name: null,
    },
    orderClicked: false,
    notify: null,
    imgPath: process.env.BASE_URL,
  }),
  methods: {
    ClearTimer() {
      if (this.paymentObject) {
        this.paymentObject.close();
      }
      else {
        axios.post(URL + "ticketRelease", { master: this.seatdetail.omid, thid: 1 }, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
          }
        });
      }

    },

    removefromcart(prdctid) {
      delete this.qnty[prdctid];
      this.$emit("removeproduct", prdctid)
    },

    confirmOrder() {

      for (const key in this.cartdetails) {
        var curitm = this.cartdetails[key].pdtid;
        this.qnty[curitm] = this.cartdetails[key].qty;
        this.proid.push(curitm);
      }
      let valid = true;
      let ermsg = "<div class='text-danger'>";
      if (!this.customer.name) {
        valid = false;
        ermsg += 'Please Enter your name<br>';
      }
      //eslint-disable-next-line
      var emlexp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if (!emlexp.test(this.customer.email)) {
        valid = false;
        ermsg += 'Please enter valid email ID<br>';
      }

      const filter = /^\d{10}$/;
      //eslint-disable-next-line
      if (!filter.test(this.customer.mobile)) {
        valid = false;
        ermsg += "Enter a valid 10 digit mobile number (without leading zero and +91)</br>";
      }
      this.notify = ermsg;
      if (!valid) {
        ermsg += "</div>";
        this.notify = ermsg;
        return
      }
      this.orderClicked = true;

      axios.post(URL + "proceedBooking", { qnty: this.qnty, proid: this.proid, seatdetail: this.seatdetail, customer: this.customer }, {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        }
      }).then((response) => {
        document.getElementById('loadpaym').style.display="block";
        this.orderClicked = false;
        var resp = response.data;
        var resno = this.seatdetail.resno;
        var qnty = this.qnty;
        var proid = this.proid;
        var route = this.$router;
        var curomid=this.seatdetail.omid;
        if (response.data.status == 'success') {
          var razorpay = JSON.parse(response.data.razorpay);
          const options = {
            key: 'rzp_live_U9vU49mO83Qbb1',
            amount: razorpay.amount,
            currency: 'INR',
            name: 'Palaxi Cinemas',
            description: curomid,
            order_id: razorpay.id,
            image: this.imgPath+'ico/apple-touch-icon-57-precomposed.png',
            handler:
              function () {
                axios.post(URL + "confirmBooking", { qnty: qnty, proid: proid, shId: resp.showId.sh_id, status: 'success', resno: resno }, {
                  headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                  }
                }).then(() => {
                  route.push("../bookingsuccess/" + resp.showId.resno);
                });
              },
            "modal": {
              "ondismiss": function () {
                axios.post(URL + "ticketRelease", { master: resp.showId.omid, thid: 1 }, {
                  headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                  }
                }).then(() => {
                  window.location.replace("/");
                })
              },
              escape: true,
   backdropclose: false
            },
            prefill: {
              name: this.customer.name,
              email: this.customer.email,
              contact: this.customer.mobile
            },
            notes:{order:resno}
          };
          this.paymentObject = new window.Razorpay(options);
          this.paymentObject.on('payment.failed', function() {
            window.location.replace("/notfound");
 });
          this.paymentObject.open();
          
        }
        else {
          console.log("something went wrong");
        }
      }

      );

    },
    getUser() {
      axios
        .get(URL + "checkLogin?code=" + localStorage.getItem("loginCode"))
        .then((response) => {
          if (response.data.status == "done") {
            this.customer = response.data;
          }
        })
    }


  },
  computed: {
    cafetotalPrice() {
      let total = 0;
      for (const productId in this.cartdetails) {
        const product = this.cartdetails[productId];
        total += product.qty * product.pdtprice;
      }
      return total;
    },

  },
  emits: ['removeproduct'],
  mounted() {
console.log(this.seatdetail);
    this.getUser();
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://checkout.razorpay.com/v1/checkout.js');
    document.head.appendChild(recaptchaScript);
  }
}
  
 </script>         